import {
    Center, Title, Accordion, Container, Text, Group, Button, Modal, Select, Textarea, TextInput, Input, LoadingOverlay, Box, SimpleGrid,
    Card,
    ThemeIcon,
    Badge,
    Stack, Divider, Paper
} from "@mantine/core";
import { useEffect, useState } from "react";
import { Userauthcontexthooks } from "../Hooks/Userauthcontexthooks";
import { Popconfirm, message, DatePicker } from "antd";
import { useDisclosure } from '@mantine/hooks';
import dayjs from 'dayjs';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import UpcomingIcon from '@mui/icons-material/Upcoming';
import EditNoteIcon from '@mui/icons-material/EditNote';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import GavelIcon from '@mui/icons-material/Gavel';
import PersonIcon from '@mui/icons-material/Person';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import LocalPoliceIcon from '@mui/icons-material/LocalPolice';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Newnavbar from "../Components/Navbar/Newnavbar";
import { IconEdit, IconDeviceFloppy } from "@tabler/icons-react";



const AlertHistory = () => {
    const { user } = Userauthcontexthooks();
    const [AlertHistory, setAlertHistory] = useState([]);
    const [IndividualAlert, setIndividualAlert] = useState([]);
    const [overlayloading, setoverlayloding] = useState(true);
    const [loading, setLoading] = useState({
        delloading: false,
        editbtnloading: false,
        alertloading: true,
    });
    const [opened, { open, close }] = useDisclosure(false);
    const [Alertinputs, setalertsinputs] = useState({
        courtno: '',
        judgename: '',
        policestation: '',
        clientname: '',
        clientemail: '',
        caseyear: '',
        firsthearingdate: '',
        narration: ''
    })
    const [Notificationdate, setNotificationdate] = useState(null); // For Date ALert
    const [selectcourt, setselectcourt] = useState(''); // For Date ALert
    const [selectsubdistcourt, setselectsubdistcourt] = useState('') // For Date ALert
    const [selecthighcourt, setselecthighcourt] = useState('') // For Date ALert
    const [selectcasetype, setselectcasetype] = useState('') // For Date ALert

    const Alertonchange = (e) => {
        const { name, value } = e.target;
        setalertsinputs({ ...Alertinputs, [name]: value })
    }
    const DateonChange = (date) => {
        setNotificationdate(date);
    };
    const parseDate = (dateStr) => {
        const [day, month, year] = dateStr.split('-');
        return new Date(`${year}-${month}-${day}`);
    };

    const Get_Individual_Alert = async () => { // for getting individual alert update 
        const res = await fetch('https://cdr-backend.onrender.com/get/individualalert', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user}`
            }
        });
        if (res.status === 200) {
            const data = await res.json();
            const now = new Date();
            now.setHours(0, 0, 0, 0);

            const upcoming = data.IndividualAlert.filter(item => {
                const notifDate = parseDate(item.notificationdate);
                notifDate.setHours(0, 0, 0, 0);
                return notifDate >= now;
            }).sort((a, b) => parseDate(a.notificationdate) - parseDate(b.notificationdate));

            const past = data.IndividualAlert.filter(item => {
                const notifDate = parseDate(item.notificationdate);
                notifDate.setHours(0, 0, 0, 0);
                return notifDate < now;
            }).sort((a, b) => parseDate(a.notificationdate) - parseDate(b.notificationdate));

            const finalSortedAlerts = [...upcoming, ...past];

            setAlertHistory(finalSortedAlerts);
            // setAlertHistory(data.IndividualAlert);
            setLoading({ ...loading, alertloading: false });
            return;
        }

    }
    // const Get_Alert_For_Edit = async (_id) => {
    //     const res = await fetch('https://cdr-backend.onrender.com/get/alert-for-edit/' + _id, {
    //         method: 'GET',
    //         headers: {
    //             'Content-Type': 'application/json',
    //             'Authorization': `Bearer ${user}`
    //         }
    //     });
    //     if (res.status === 200) {
    //         const data = await res.json();
    //         setIndividualAlert(data.IndividualAlert);
    //         setoverlayloding(false);
    //         // setLoading({ ...loading, editoverlayloading: false });
    //         return;
    //     } else {
    //         message.error('Alert Not Found');
    //         setoverlayloding(false);
    //         //setLoading({ ...loading, editoverlayloading: false });
    //         return;
    //     }
    // }
    const Get_Alert_For_Edit = async (_id) => {
        setoverlayloding(true);

        const res = await fetch(
            'https://cdr-backend.onrender.com/get/alert-for-edit/' + _id,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`
                }
            }
        );

        if (res.status === 200) {
            const data = await res.json();
            const alert = data.IndividualAlert;
            //console.log(alert);

            setIndividualAlert(alert);

            // Auto fill all fields
            setselectcourt(alert.selectcourt || '');
            setselectsubdistcourt(alert.selectsubdistcourt || '');
            setselectcasetype(alert.selectcasetype || '');

            setalertsinputs({
                courtno: alert.courtno || '',
                judgename: alert.judgename || '',
                policestation: alert.policestation || '',
                clientname: alert.clientname || '',
                clientemail: alert.clientemail || '',
                caseyear: alert.caseyear || '',
                firsthearingdate: alert.firsthearingdate || '',
                narration: alert.narration || ''
            });
            setNotificationdate(
                dayjs(
                    data.IndividualAlert.notificationdate,
                    "DD-MM-YYYY"
                )
            );
            setoverlayloding(false);
        } else {
            message.error('Alert Not Found');
            setoverlayloding(false);
        }
    };
    const Del_Alert = async (_id) => {
        setLoading({ ...loading, delloading: true });
        const res = await fetch('https://cdr-backend.onrender.com/delete/alert/' + _id, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user}`
            }
        });
        if (res.status === 200) {
            message.success('Alert Deleted Successfully');
            Get_Individual_Alert();
            setLoading({ ...loading, delloading: false });
            return;
        } else {
            message.error('Alert Not Deleted');
            setLoading({ ...loading, delloading: false });
            return;
        }

    }
    const confirm = (_id) => {
        Del_Alert(_id);
    };
    const OpenEditmodal = async (_id) => {
        Get_Alert_For_Edit(_id);
        open();
    }

    const EditAlert = async () => {
        const _id = IndividualAlert._id;
        setLoading({ ...loading, editbtnloading: true });
        const { courtno, judgename, policestation, clientname, clientemail, caseyear, firsthearingdate, narration } = Alertinputs;
        const notificationdate = dayjs(Notificationdate).format('DD-MM-YYYY'); // for input.

        const res = await fetch('https://cdr-backend.onrender.com/edit-alert/' + _id, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user}`
            },
            body: JSON.stringify({ selectcourt, selectcasetype, selectsubdistcourt, selecthighcourt, courtno, judgename, policestation, clientname, clientemail, caseyear, firsthearingdate, notificationdate, narration })
        });

        if (res.status === 200) {
            message.success('Alert Edited Successfully');
            setLoading({ ...loading, editbtnloading: false });
            setalertsinputs({
                courtno: '',
                courtname: '',
                policestation: '',
                clientname: '',
                clientemail: '',
                caseyear: '',
                firsthearingdate: '',
                narration: ''
            })
            setselectcourt('');
            setselectsubdistcourt('');
            setselectcasetype('');
            setNotificationdate('');
            close();
            Get_Individual_Alert();
            return;
        } else {
            message.error('Alert Not Edited');
            setLoading({ ...loading, editbtnloading: false });
            return;
        }
    }


    // const items = AlertHistory.map((item) => {
    //     const now = new Date();
    //     const notificationDate = parseDate(item.notificationdate);
    //     const isPast = notificationDate < now;
    //     return (
    //         <Accordion.Item key={item._id} value={item.clientname}>
    //             <Accordion.Control>
    //                 <Text c={isPast ? 'green' : 'black'}>
    //                     Client: {item.clientname}, Court: {item.courtname}, Type: {item.selectcasetype}
    //                     {isPast ? ' (Past)' : ' (Upcoming)'}
    //                 </Text>
    //             </Accordion.Control>
    //             {/* <Accordion.Control>Client Name.: {item.clientname}, Court Name.: {item.courtname}, Case Type.: {item.selectcasetype}</Accordion.Control> */}
    //             <Accordion.Panel>
    //                 <Text size="sm">Client Name.: {item.clientname}</Text>
    //                 <Text size="sm">Client Email.: {item.clientemail}</Text>
    //                 <Text size="sm">Case Year.: {item.caseyear}</Text>
    //                 <Text size="sm">First Hearing Date.: {item.firsthearingdate}</Text>
    //                 <Text size="sm">Next Hearing Date.: {item.notificationdate}</Text>
    //                 <Text size="sm">Court No.: {item.courtno}</Text>
    //                 <Text size="sm">Court Name.: {item.courtname}</Text>
    //                 <Text size="sm">Judge Name.: {item.judgename}</Text>
    //                 <Text size="sm">Police Station.: {item.policestation}</Text>
    //                 <Text size="sm">Case Type.: {item.selectcasetype}</Text>
    //                 <Text size="sm">Sub Dist Court Name.: {item.selectsubdistcourt}</Text>
    //                 <Text size="sm">Narration.: {item.narration}</Text>
    //                 <Group justify="flex-end">
    //                     <Button size="xs" onClick={() => OpenEditmodal(item._id)}>Edit</Button>
    //                     <Popconfirm
    //                         title="Delete the alert"
    //                         description="Are you sure to delete this alert?"
    //                         onConfirm={() => confirm(item._id)}
    //                         okText="Yes"
    //                         cancelText="No"
    //                     >
    //                         <Button color="red" size="xs" loading={loading.delloading} disabled={loading.delloading}>Delete</Button>
    //                     </Popconfirm>

    //                 </Group>
    //             </Accordion.Panel>
    //         </Accordion.Item>
    //     )

    // });

    useEffect(() => {

        if (user) {
            const Get_Individual_Alert = async () => {
                const res = await fetch('https://cdr-backend.onrender.com/get/individualalert', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${user}`
                    }
                });
                if (res.status === 200) {
                    const data = await res.json();
                    const now = new Date();
                    now.setHours(0, 0, 0, 0);

                    const upcoming = data.IndividualAlert.filter(item => {
                        const notifDate = parseDate(item.notificationdate);
                        notifDate.setHours(0, 0, 0, 0);
                        return notifDate >= now;
                    }).sort((a, b) => parseDate(a.notificationdate) - parseDate(b.notificationdate));

                    const past = data.IndividualAlert.filter(item => {
                        const notifDate = parseDate(item.notificationdate);
                        notifDate.setHours(0, 0, 0, 0);
                        return notifDate < now;
                    }).sort((a, b) => parseDate(a.notificationdate) - parseDate(b.notificationdate));

                    const finalSortedAlerts = [...upcoming, ...past];

                    setAlertHistory(finalSortedAlerts);
                    // setAlertHistory(data.IndividualAlert);
                    setLoading({ ...loading, alertloading: false });
                    return;
                }

            }
            Get_Individual_Alert();
        }

    }, [user, loading])
    return (
        <>
            <Modal
                opened={opened}
                onClose={close}
                centered
                size="lg"
                radius="xl"
                title={
                    <Group gap="xs">
                        <IconEdit size={22} color="#3b82f6" />
                        <Text fw={700} size="lg">
                            Edit Court Alert
                        </Text>
                    </Group>
                }
            >
                <LoadingOverlay
                    visible={overlayloading}
                    zIndex={1000}
                    overlayProps={{
                        blur: 4,
                        radius: "xl",
                        variant: "filled",
                    }}
                    loaderProps={{ color: "blue", type: "bars" }}
                />

                <Stack gap="md">

                    <Paper
                        p="md"
                        radius="xl"
                        bg="rgba(59,130,246,0.08)"
                        style={{
                            border: "1px solid rgba(59,130,246,0.2)"
                        }}
                    >
                        <Text size="sm" c="dimmed">
                            Update your alert information below.
                            Changes will immediately reflect in your reminder history.
                        </Text>
                    </Paper>

                    <Select
                        label="Court"
                        placeholder="Select Court"
                        radius="xl"
                        data={[
                            'Supreme court',
                            'High court',
                            'Dist. court'
                        ]}
                        value={selectcourt}
                        onChange={setselectcourt}
                    />

                    {/* {selectcourt === "Dist. court" && (
                        <Select
                            label="District Court"
                            radius="xl"
                            searchable
                            data={[
                                'Tis Hazari courts',
                                'Rose Avenue courts',
                                'Karkardooma courts',
                                'Patiala House courts',
                                'Rohini courts',
                                'Dwarka courts',
                                'Saket courts',
                            ]}
                            value={selectsubdistcourt}
                            onChange={setselectsubdistcourt}
                        />
                    )} */}
                    {selectcourt === "Dist. court" && (
                        <>
                            <TextInput
                                radius="xl"
                                label={'District Court'}
                                placeholder={'District Court'}
                                // name={field.name}
                                value={selectsubdistcourt}
                                onChange={(e) => setselectsubdistcourt(e.target.value)}
                            />
                            {/* <Select
                label="Select District Court"
                placeholder="Choose District Court"
                data={[
                  "Tis Hazari courts",
                  "Rouse Avenue courts",
                  "Karkardooma courts",
                  "Patiala House courts",
                  "Rohini courts",
                  "Dwarka courts",
                  "Saket courts",
                ]}
                value={selectsubdistcourt}
                onChange={(value) => setselectsubdistcourt(value)}
                withAsterisk
                radius="xl"
                searchable
                size="md"
                styles={{
                  label: {
                    color: "#e2e8f0",
                    marginBottom: 6,
                    fontWeight: 600,
                  },
                  input: {
                    background: "rgba(255,255,255,0.05)",
                    border: "1px solid rgba(255,255,255,0.1)",
                    color: "white",
                    height: 52,
                  },
                }}
              /> */}

                        </>
                    )}
                    {selectcourt === "High court" && (
                        <>
                            <TextInput
                                radius="xl"
                                label={'High Court'}
                                placeholder={'High Court'}
                                // name={field.name}
                                value={selecthighcourt}
                                onChange={(e) => setselecthighcourt(e.target.value)}
                            />
                        </>
                    )}

                    {(selectcourt === "Dist. court" ||
                        selectcourt === "High court" ||
                        selectcourt === "Supreme court") && (
                            <Select
                                label="Select Case Type"
                                placeholder="Choose Case Type"
                                data={
                                    selectcourt === "Dist. court"
                                        ? ['ARBTN- ARBRITRATION CASES', 'BAIL MATTERS- BAIL CASE TYPE', 'CA- CRIMINAL APPEAL', 'CBI- CBI', 'CC- CORRUPTION CASES', 'CC NI ACT- COMPLAINT CASE 138 NI ACT', 'CIV DJ- CIVIL SUIT FOR DJ AND ADJ', 'CIV SCJ- CIVIL SUIT FOR CIVIL JUDGE', 'CLO_R- CLOSURE REPORT', 'COUNTER CLAIM', 'COURT COMPLAINT', 'CR- COPY RIGHT', 'CR CASES- CRIMINAL CASE', 'CR REV- CRIMINAL REVISION', 'CT CASES- COMPLAINT CASES', 'DE- DEPARTMENTAL ENQUIRY', 'DE CRL- DEPARTMENTAL ENQUIRY CRIMINAL', 'E.P.- ELECTION PETITTION', 'ESIC- EMPLOYEE STATE INSURANCE ACT', 'EX- EXECUTION', 'EX CRL- EXECUTION', 'FACT F- FACT FINDING ENQUIRY', 'FSAT- FOOD SAFTY APPELLATE TRIBUNAL', 'GP- GUARDIAN CASES', 'HINDU ADP.- HINDU ADOPTATION MAINT. ACT', 'HMA- HINDU MARRIAGE ACT', 'HTA- HOUSE TAX APPEAL', 'IDA- DEVORCE ACT', 'INSOLVENCY- INSOLVENCY CASE', 'ITA- INDUSTRIAL TRIBUNAL', 'LAC- LAND ACQ. ACT', 'LC- LABOUR COURT', 'LCA- LABOUR COURT APPLICATION', 'LIR- LABOUR/IND. TRIB REF MATTER', 'M- MISC. CASES', 'M.A.C.T- M.A.C.T', 'MACT CRL- MACT CRIMINAL', 'MC- MAHILA COURT', 'MCA DJ- MISC. CIVIL APPEAL FOR DJ ADJ', 'MCA SCJ- MISC. APPEAL FOR CJ', 'MCD APPL- MCA APPEAL', 'M-EX- MISC. EXECUTION', 'MGP- MISC. GUARDIANSHIP CASES', 'MHA- MENTAL HEALTH CASES', 'MISC DJ- MISC. CASES FOR DJ AND DJ', 'MISC SCJ- MISC. CASES FOR CJ', 'MPC- MISC. PROBATE CASES', 'MUSLIM LAW- MUSLIM LAW DELHI WAQF BOARD', 'OP- APPROVAL', 'PC- PROBATE/LETTER', 'PPA- PUBLIC PREMISES ACT', 'RCA DJ- REG. CIVIL APPEAL FOR DJ ADJ', 'RC ARC- RENT CONTROLLER ADDL. R.C.', 'RCA SCJ- CIVIL APPEAL FOR CJ', 'RCT ARCT- RENT CNTRL TRIBUNAL ADDL. RCT', 'REC. CASES- RECEIVERSHIP CASES', 'REVOCATION', 'RP- REVISION PETITION', 'RTI APPEAL- RIGHT TO INFORMATION ACT. APPL.', 'SC- SESSIONS CASE', 'SMA- SPECIAL MARRIAGE ACT', 'SMALL CAUSE- SMALL CAUSE COURT', 'SUCC. COURT- SUCCESSION COURT', 'TM- TRADE MARKS', 'T.P.(C)- TRANSFER APPLICATION', 'T.P.(CRL)- TRANSFER APPLICATION (CRL)', 'TRAFFIC CHALLAN', 'OTHER(S)']
                                        : selectcourt === "High court"
                                            ? ['ADMIN. REPORT', 'ARB. A.', 'ARB.A. (COMM.)', 'ARB.P.', 'BAIL APPLN', 'CA', 'CA (COMM.IPD-CR)', 'C.A. (COMM.IPD-GI)', 'C.A. (COMM.IPD.-PAT)', 'C.A. (COMM.IPD-PV)', 'C.A. (COMM.IPD-TM)', 'CAVEAT(CO.)', 'CC(ARB.)', 'CCP(CO.)', 'CCP(REF)', 'CEAC', 'CEAR', 'CHAT.A.C.', 'CHAT.A.REF.', 'CMI', 'CM(M)', 'CM(M)-IPD', 'C.O.', 'CO.APP.', 'CO.APPL.(C)', 'CO.APPL.(M)', 'C.O.A.(SB)', 'C.O.(COMM.IPD-CR)', 'C.O.(COMM.IPD-GI)', 'C.O.(COMM.IPD-PAT)', 'C.O.(COMM.IPD-TM)', 'CO.EX.', 'CONT.APP.(C)', 'CONT.CAS(C)', 'CONT.CAS.(CRL)', 'CO.P.E.T.', 'C.REF.(O)', 'CRL.A.', 'CRL.L.P.', 'CRL.M.C.', 'CRL.M.(CO.)', 'CRL.M.I', 'CRL.O.', 'CRL.O.(CO.)', 'CRL.REF.', 'CRL.REV.P.', 'CRL.REVP.(MAT.)', 'CRL.REV.P.(NDPS)', 'CRL.REVP.(NI)', 'C.R.P.', 'CRP-IPD', 'C.RULE', 'CS(COMM)', 'CS(OS)', 'CS(OS)GP', 'CUSAA', 'CUS.A.C.', 'CUS.A.R.', 'CUSTOM A.', 'DEATH SENTENCE REF.', 'DEMO', 'EDC', 'EDR', 'EFA(COMM)', 'EFA(OS)', 'EFA(OS) (COMM)', 'EFA(OS)(IPD)', 'EL.PET.', 'ETR', 'EX.F.A.', 'EX.P.', 'EX.S.A', 'FAO', 'FAO(COMM)', 'FAO-IPD', 'FAO(OS)', 'FAO(OS) (COMM)', 'FAO(OS) (IPD)', 'GCAC', 'GCAR', 'GTA', 'GTC', 'GTR', 'I.A.', 'I.P.A.', 'ITA', 'ITC', 'ITR', 'ITSA', 'LA.APP.', 'LPA', 'MAC.APP', 'MAT', 'MAT.APP.', 'MAT.APP.(F.C.)', 'MAT.CASE', 'MAT.REF.', 'MISC. APPEAL(PMLA)', 'OA', 'OCJA', 'O.M.P.', 'O.M.P. (COMM)', 'OMP (CONT.)', 'O.M.P.(E) (COMM.)', 'O.M.P.(I)', 'O.M.P(J) (COMM.)', 'O.M.P.(MISC.)', 'O.M.P.(MISC.)(COMM.)', 'O.M.P.(T)', 'O.M.P.(T)(COMM)', 'O.REF.', 'RC.REV.', 'RC.S.A.', 'RERA APPEAL', 'REVIEW PET.', 'RFA', 'RFA(COMM)', 'RFA-IPD', 'RFA(OS)', 'RFA(OS)(COMM)', 'RF(OS)(IPD)', 'RSA', 'SCA', 'SDR', 'SERTA', 'ST.APPL.', 'STC', 'ST.REF.', 'SUR.T.REF.', 'TEST.CAS.', 'TR.P.(C)', 'TR.P.(C.)', 'TR.P.(CRL.)', 'VAT APPEAL', 'W.P.(C)', 'W.P.(C)-IPD', 'WP(C)(IPD)', 'W.P.(CRL)', 'WTA', 'WTC', 'WTR', 'OTHER(S)']
                                            : ['SPECIAL LEAVE PETITION (CIVIL)', 'SPECIAL LEAVE PETITION (CRIMMINAL)', 'CIVIL APPEAL', 'CRIMINAL APPEAL', 'WRIT PETITION (CIVIL)', 'WRIT PETITION (CRIMINAL)', 'TRANSFER PETITION (CIVIL)', 'TRANSFER PETITION (CRIMINAL)', 'REVIEW PETITION (CIVIL)', 'REVIEW PETITION (CRIMINAL)', 'TRANSFERRED CASE (CIVIL)', 'TRANSFERED CASE (CRIMINAL)', 'SPECIAL LEAVE TO PETITION (CIVIL)', 'SPECIAL LEAVE TO PETITION (CRIMINAL)', 'WRIT TO PETITION (CIVIL)', 'WRIT TO PETITION (CRIMINAL)', 'ORIGINAL SUIT', 'DEATH REFERENCE CASE', 'CONTEMPT PETITION (CIVIL)', 'CONTEMPT PETITION (CRIMINAL)', 'TAX REFERENCE CASE', 'SPECIAL REFERENCE CASE', 'ELECTION PETITION (CIVIL)', 'ARBITRATION PETITION', 'CURATIVE PETITION (CIVIL)', 'CURATIVE PETITION (CRL)', 'REF. U/A 317(1)', 'MOTION (CRL)', 'DIARYNO AND DIARYYR', 'SUO MOTO WRIT PETITION (CIVIL)', 'SUO MOTO WRIT PETITION (CRIMINAL)', 'SUO MOTO CONTEMPT PETITION (CIVIL)', 'SUO MOTO CONTEMPT PETITION (CRIMINAL)', 'REF. U/S 14 RTI', 'REF. U/S 17 RTI', 'MISC. APPLICATION', 'SUO MOTO TRANSFER PETITION (CIVIL)', 'SUO MOTO TRANSFER PETITION (CRIMINAL)', 'OTHER(S)']
                                }
                                value={selectcasetype}
                                onChange={setselectcasetype}
                            />
                        )}

                    <SimpleGrid cols={{ base: 1, sm: 2 }}>

                        <TextInput
                            label="Court Number"
                            radius="xl"
                            value={Alertinputs.courtno}
                            name="courtno"
                            onChange={Alertonchange}
                        />

                        <TextInput
                            label="Judge Name"
                            radius="xl"
                            value={Alertinputs.judgename}
                            name="judgename"
                            onChange={Alertonchange}
                        />

                        <TextInput
                            label="Police Station"
                            radius="xl"
                            value={Alertinputs.policestation}
                            name="policestation"
                            onChange={Alertonchange}
                        />

                        <TextInput
                            label="Case Year"
                            radius="xl"
                            value={Alertinputs.caseyear}
                            name="caseyear"
                            onChange={Alertonchange}
                        />

                        <TextInput
                            label="Client Name"
                            radius="xl"
                            value={Alertinputs.clientname}
                            name="clientname"
                            onChange={Alertonchange}
                        />

                        <TextInput
                            label="Client Email"
                            radius="xl"
                            value={Alertinputs.clientemail}
                            name="clientemail"
                            onChange={Alertonchange}
                        />

                    </SimpleGrid>

                    <TextInput
                        label="First Hearing Date"
                        radius="xl"
                        value={Alertinputs.firsthearingdate}
                        name="firsthearingdate"
                        onChange={Alertonchange}
                    />

                    <Input.Wrapper label="Notification Date">
                        <DatePicker
                            name="notificationdate"
                            value={Notificationdate}
                            onChange={DateonChange}
                            placeholder="Select Date"
                            format="DD-MM-YYYY"
                        />
                    </Input.Wrapper>

                    <Textarea
                        label="Narration"
                        radius="xl"
                        minRows={4}
                        autosize
                        value={Alertinputs.narration}
                        name="narration"
                        onChange={Alertonchange}
                    />

                    <Button
                        fullWidth
                        radius="xl"
                        size="md"
                        loading={loading.editbtnloading}
                        leftSection={<IconDeviceFloppy size={18} />}
                        variant="gradient"
                        gradient={{
                            from: "blue",
                            to: "cyan"
                        }}
                        onClick={EditAlert}
                    >
                        Save Changes
                    </Button>

                </Stack>
            </Modal>

            {/* <Modal opened={opened} onClose={close} title="Edit Alert">
                <Box pos="relative">

                    <LoadingOverlay
                        visible={overlayloading}
                        zIndex={1000}
                        overlayProps={{ radius: "sm", blur: 2 }}
                        loaderProps={{ color: "pink", type: "bars" }}
                    />

                    <Select
                        label={`Prev Selected Court.: ${IndividualAlert.selectcourt || ""}`}
                        placeholder="Pick value"
                        data={["Supreme court", "High court", "Dist. court"]}
                        mt="xs"
                        name="court"
                        value={selectcourt}
                        onChange={(value) => setselectcourt(value)}
                    />

                    {(IndividualAlert.selectcourt === "Dist. court" ||
                        selectcourt === "Dist. court") && (
                            <Select
                                label={`Prev Selected Sub Dist. Court.: ${IndividualAlert.selectsubdistcourt || ""
                                    }`}
                                placeholder="Pick value"
                                data={[
                                    "Tis Hazari courts",
                                    "Rose Avenue courts",
                                    "Karkardooma courts",
                                    "Patiala House courts",
                                    "Rohini courts",
                                    "Dwarka courts",
                                    "Saket courts",
                                ]}
                                mt="xs"
                                name="subdistcourt"
                                value={selectsubdistcourt}
                                onChange={(value) => setselectsubdistcourt(value)}
                            />
                        )}

                    <Select
                        label={`Prev Selected Case Type.: ${IndividualAlert.selectcasetype || ""
                            }`}
                        placeholder="Pick value"
                        // data={caseTypeOptions} // your huge array
                        mt="xs"
                        name="casetype"
                        value={selectcasetype}
                        onChange={(value) => setselectcasetype(value)}
                        searchable
                        withAsterisk
                    />

                    <TextInput
                        radius="lg"
                        label={`Prev Court No.: ${IndividualAlert.courtno || ""}`}
                        placeholder="123"
                        mt="sm"
                        name="courtno"
                        value={Alertinputs.courtno}
                        onChange={Alertonchange}
                    />

                    <TextInput
                        radius="lg"
                        label={`Prev Court Name.: ${IndividualAlert.selectcourt || ""}`}
                        name="courtname"
                        value={selectcourt}
                        onChange={Alertonchange}
                        placeholder="Auto selected court name"
                        mt="sm"
                        disabled
                    />

                    <TextInput
                        radius="lg"
                        label={`Enter Judge Name.: ${IndividualAlert.judgename || ""}`}
                        placeholder="Judge name"
                        mt="sm"
                        name="judgename"
                        value={Alertinputs.judgename}
                        onChange={Alertonchange}
                    />

                    <TextInput
                        radius="lg"
                        label={`Prev Police Station.: ${IndividualAlert.policestation || ""
                            }`}
                        placeholder="Police station"
                        mt="sm"
                        name="policestation"
                        value={Alertinputs.policestation}
                        onChange={Alertonchange}
                    />

                    <TextInput
                        radius="lg"
                        label={`Prev Client Name.: ${IndividualAlert.clientname || ""}`}
                        placeholder="Client name"
                        mt="sm"
                        name="clientname"
                        value={Alertinputs.clientname}
                        onChange={Alertonchange}
                    />

                    <TextInput
                        radius="lg"
                        label={`Prev Client Email.: ${IndividualAlert.clientemail || ""}`}
                        placeholder="Client email"
                        mt="sm"
                        name="clientemail"
                        value={Alertinputs.clientemail}
                        onChange={Alertonchange}
                    />

                    <TextInput
                        radius="lg"
                        label={`Prev Case Year.: ${IndividualAlert.caseyear || ""}`}
                        placeholder="Case year"
                        mt="sm"
                        name="caseyear"
                        value={Alertinputs.caseyear}
                        onChange={Alertonchange}
                    />

                    <TextInput
                        radius="lg"
                        label={`Prev Entered First Hearing Date.: ${IndividualAlert.firsthearingdate || ""
                            }`}
                        placeholder="First hearing date"
                        mt="sm"
                        name="firsthearingdate"
                        value={Alertinputs.firsthearingdate}
                        onChange={Alertonchange}
                    />

                    <Input.Wrapper
                        label={`Prev Selected Notification Date.: ${IndividualAlert.notificationdate || ""
                            }`}
                        mt="sm"
                    >
                        <DatePicker
                            value={Notificationdate}
                            onChange={DateonChange}
                            style={{ marginLeft: "5px" }}
                            name="notificationdate"
                            format="DD-MM-YYYY"
                            placeholder="Select Date"
                        />
                    </Input.Wrapper>

                    <Textarea
                        label={`Prev Narration.: ${IndividualAlert.narration || ""}`}
                        placeholder="Write something..."
                        autosize
                        mt="sm"
                        name="narration"
                        value={Alertinputs.narration}
                        onChange={Alertonchange}
                    />

                    <Button
                        variant="light"
                        color="orange"
                        size="md"
                        fullWidth
                        mt="md"
                        loading={loading.editbtnloading}
                        disabled={loading.editbtnloading}
                        onClick={EditAlert}
                    >
                        Edit
                    </Button>

                </Box>
            </Modal> */}
            {/* ===================== ALERT HISTORY PAGE UI ===================== */}

            <Box
                style={{
                    minHeight: "100vh",
                    background:
                        "linear-gradient(135deg,#020617 0%,#0f172a 40%,#111827 100%)",
                    position: "relative",
                    overflow: "hidden",
                }}
            >
                {/* BACKGROUND GLOW */}
                <Box
                    style={{
                        position: "absolute",
                        width: 500,
                        height: 500,
                        borderRadius: "50%",
                        background: "rgba(59,130,246,0.15)",
                        filter: "blur(120px)",
                        top: -100,
                        right: -100,
                    }}
                />
                <Box
                    style={{
                        position: "absolute",
                        width: 400,
                        height: 400,
                        borderRadius: "50%",
                        background: "rgba(168,85,247,0.15)",
                        filter: "blur(120px)",
                        bottom: -100,
                        left: -100,
                    }}
                />
                {/* MAIN CONTENT */}
                <Box
                    px={{ base: "md", md: "xl" }}
                    py={{ base: "md", md: "lg" }}
                    style={{
                        position: "relative",
                        zIndex: 10,
                        paddingBottom: 100,
                    }}
                >
                    <Newnavbar />
                    <Container size="xl" mt="md" mb="xl">

                        {/* HEADER */}
                        <Card
                            radius="2xl"
                            p="xl"
                            mb="lg"
                            style={{
                                background: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)',
                                color: 'white',
                                border: '1px solid rgba(255,255,255,0.08)'
                            }}
                        >
                            <Group justify="space-between" align="center">
                                <Box>
                                    <Title order={2} c="white">
                                        Alert History
                                    </Title>

                                    <Text c="gray.3" mt={4}>
                                        Manage all your upcoming and completed court alerts
                                    </Text>
                                </Box>

                                <ThemeIcon
                                    size={65}
                                    radius="xl"
                                    variant="light"
                                    color="orange"
                                >
                                    <NotificationsActiveIcon style={{ fontSize: 34 }} />
                                </ThemeIcon>
                            </Group>
                        </Card>

                        {/* STATS CARDS */}
                        <SimpleGrid cols={{ base: 1, sm: 2, lg: 4 }} mb="xl">

                            {/* TOTAL */}
                            <Card
                                radius="xl"
                                p="lg"
                                shadow="sm"
                                withBorder
                                style={{
                                    background: 'linear-gradient(135deg,#eff6ff 0%,#dbeafe 100%)'
                                }}
                            >
                                <Group justify="space-between">
                                    <Box>
                                        <Text size="sm" c="dimmed" fw={600}>
                                            Total Alerts
                                        </Text>

                                        <Title order={2}>
                                            {AlertHistory.length}
                                        </Title>
                                    </Box>

                                    <ThemeIcon
                                        size={55}
                                        radius="xl"
                                        color="blue"
                                        variant="light"
                                    >
                                        <NotificationsActiveIcon />
                                    </ThemeIcon>
                                </Group>
                            </Card>

                            {/* ACTIVE */}
                            <Card
                                radius="xl"
                                p="lg"
                                shadow="sm"
                                withBorder
                                style={{
                                    background: 'linear-gradient(135deg,#fff7ed 0%,#ffedd5 100%)'
                                }}
                            >
                                <Group justify="space-between">
                                    <Box>
                                        <Text size="sm" c="dimmed" fw={600}>
                                            Active Alerts
                                        </Text>

                                        <Title order={2}>
                                            {
                                                AlertHistory.filter((item) => {
                                                    const notifDate = parseDate(item.notificationdate);
                                                    const now = new Date();
                                                    now.setHours(0, 0, 0, 0);

                                                    return notifDate >= now;
                                                }).length
                                            }
                                        </Title>
                                    </Box>

                                    <ThemeIcon
                                        size={55}
                                        radius="xl"
                                        color="orange"
                                        variant="light"
                                    >
                                        <EventAvailableIcon />
                                    </ThemeIcon>
                                </Group>
                            </Card>

                            {/* COMPLETED */}
                            <Card
                                radius="xl"
                                p="lg"
                                shadow="sm"
                                withBorder
                                style={{
                                    background: 'linear-gradient(135deg,#ecfdf5 0%,#d1fae5 100%)'
                                }}
                            >
                                <Group justify="space-between">
                                    <Box>
                                        <Text size="sm" c="dimmed" fw={600}>
                                            Completed Alerts
                                        </Text>

                                        <Title order={2}>
                                            {
                                                AlertHistory.filter((item) => {
                                                    const notifDate = parseDate(item.notificationdate);
                                                    const now = new Date();
                                                    now.setHours(0, 0, 0, 0);

                                                    return notifDate < now;
                                                }).length
                                            }
                                        </Title>
                                    </Box>

                                    <ThemeIcon
                                        size={55}
                                        radius="xl"
                                        color="green"
                                        variant="light"
                                    >
                                        <TaskAltIcon />
                                    </ThemeIcon>
                                </Group>
                            </Card>

                            {/* UPCOMING */}
                            <Card
                                radius="xl"
                                p="lg"
                                shadow="sm"
                                withBorder
                                style={{
                                    background: 'linear-gradient(135deg,#faf5ff 0%,#f3e8ff 100%)'
                                }}
                            >
                                <Group justify="space-between">
                                    <Box>
                                        <Text size="sm" c="dimmed" fw={600}>
                                            Upcoming Hearings
                                        </Text>

                                        <Title order={2}>
                                            {
                                                AlertHistory.filter((item) => {
                                                    const notifDate = parseDate(item.notificationdate);
                                                    const now = new Date();
                                                    now.setHours(0, 0, 0, 0);

                                                    return notifDate >= now;
                                                }).slice(0, 5).length
                                            }
                                        </Title>
                                    </Box>

                                    <ThemeIcon
                                        size={55}
                                        radius="xl"
                                        color="violet"
                                        variant="light"
                                    >
                                        <UpcomingIcon />
                                    </ThemeIcon>
                                </Group>
                            </Card>

                        </SimpleGrid>

                        {/* ALERT LIST */}
                        <Card
                            radius="2xl"
                            p="lg"
                            shadow="sm"
                            withBorder
                        >
                            <Group justify="space-between" mb="md">
                                <Box>
                                    <Title order={3}>
                                        Court Alert Records
                                    </Title>

                                    <Text size="sm" c="dimmed">
                                        View, edit and manage your saved alerts
                                    </Text>
                                </Box>

                                <Badge
                                    size="lg"
                                    radius="xl"
                                    color="orange"
                                    variant="light"
                                >
                                    {AlertHistory.length} Records
                                </Badge>
                            </Group>

                            <Divider mb="md" />

                            {
                                loading.alertloading ? (
                                    <Center py="xl">
                                        <Text size="sm">
                                            Loading alerts...
                                        </Text>
                                    </Center>
                                ) : (
                                    <Accordion
                                        variant="separated"
                                        radius="xl"
                                    >

                                        {AlertHistory.map((item, index) => {

                                            const now = new Date();
                                            now.setHours(0, 0, 0, 0);

                                            const notificationDate = parseDate(item.notificationdate);
                                            notificationDate.setHours(0, 0, 0, 0);

                                            const isPast = notificationDate < now;

                                            return (
                                                <Accordion.Item
                                                    key={item._id}
                                                    value={item._id}
                                                >

                                                    <Accordion.Control
                                                        style={{
                                                            background: isPast
                                                                ? '#f0fdf4'
                                                                : '#fff7ed',
                                                            borderRadius: '16px'
                                                        }}
                                                    >
                                                        <Group justify="space-between" wrap="wrap">

                                                            <Stack gap={2}>
                                                                <Group gap="xs">

                                                                    <ThemeIcon
                                                                        size={34}
                                                                        radius="xl"
                                                                        color={isPast ? "green" : "orange"}
                                                                        variant="light"
                                                                    >
                                                                        <GavelIcon style={{ fontSize: 18 }} />
                                                                    </ThemeIcon>

                                                                    <Box>
                                                                        <Text fw={700}>
                                                                            {item.clientname}
                                                                        </Text>

                                                                        <Text size="xs" c="dimmed">
                                                                            {item.selectcourt} • {item.selectcasetype}
                                                                        </Text>
                                                                    </Box>

                                                                </Group>
                                                            </Stack>

                                                            <Badge
                                                                color={isPast ? "green" : "orange"}
                                                                variant="light"
                                                                radius="xl"
                                                                size="lg"
                                                            >
                                                                {isPast ? 'Completed' : 'Upcoming'}
                                                            </Badge>

                                                        </Group>
                                                    </Accordion.Control>

                                                    <Accordion.Panel>

                                                        <SimpleGrid cols={{ base: 1, md: 2 }} spacing="md">

                                                            <Card radius="xl" withBorder p="md">

                                                                <Stack gap="sm">

                                                                    <Group gap="xs">
                                                                        <PersonIcon style={{ fontSize: 18, color: '#6366f1' }} />
                                                                        <Text fw={700}>
                                                                            Client Details
                                                                        </Text>
                                                                    </Group>

                                                                    <Text size="sm">
                                                                        <strong>Name:</strong> {item.clientname}
                                                                    </Text>

                                                                    <Text size="sm">
                                                                        <strong>Email:</strong> {item.clientemail}
                                                                    </Text>

                                                                    <Text size="sm">
                                                                        <strong>Case Year:</strong> {item.caseyear}
                                                                    </Text>

                                                                </Stack>

                                                            </Card>

                                                            <Card radius="xl" withBorder p="md">

                                                                <Stack gap="sm">

                                                                    <Group gap="xs">
                                                                        <AccountBalanceIcon style={{ fontSize: 18, color: '#0ea5e9' }} />
                                                                        <Text fw={700}>
                                                                            Court Details
                                                                        </Text>
                                                                    </Group>

                                                                    <Text size="sm">
                                                                        <strong>Court:</strong> {item.selectcourt}
                                                                    </Text>
                                                                    {
                                                                        item.selectcourt === "Dist. court" && <Text size="sm">
                                                                            <strong>Sub Court:</strong> {item.selectsubdistcourt}
                                                                        </Text>
                                                                    }

                                                                    {
                                                                        item.selectcourt === "High court" && <Text size="sm">
                                                                            <strong>High Court:</strong> {item.selecthighcourt}
                                                                        </Text>
                                                                    }

                                                                    <Text size="sm">
                                                                        <strong>Court No:</strong> {item.courtno}
                                                                    </Text>

                                                                    <Text size="sm">
                                                                        <strong>Judge:</strong> {item.judgename}
                                                                    </Text>

                                                                </Stack>

                                                            </Card>

                                                            <Card radius="xl" withBorder p="md">

                                                                <Stack gap="sm">

                                                                    <Group gap="xs">
                                                                        <CalendarMonthIcon style={{ fontSize: 18, color: '#f97316' }} />
                                                                        <Text fw={700}>
                                                                            Hearing Details
                                                                        </Text>
                                                                    </Group>

                                                                    <Text size="sm">
                                                                        <strong>First Hearing:</strong> {item.firsthearingdate}
                                                                    </Text>

                                                                    <Text size="sm">
                                                                        <strong>Next Hearing:</strong> {item.notificationdate}
                                                                    </Text>

                                                                    <Text size="sm">
                                                                        <strong>Case Type:</strong> {item.selectcasetype}
                                                                    </Text>

                                                                </Stack>

                                                            </Card>

                                                            <Card radius="xl" withBorder p="md">

                                                                <Stack gap="sm">

                                                                    <Group gap="xs">
                                                                        <LocalPoliceIcon style={{ fontSize: 18, color: '#ef4444' }} />
                                                                        <Text fw={700}>
                                                                            Other Details
                                                                        </Text>
                                                                    </Group>

                                                                    <Text size="sm">
                                                                        <strong>Police Station:</strong> {item.policestation}
                                                                    </Text>

                                                                    <Text size="sm">
                                                                        <strong>Narration:</strong> {item.narration}
                                                                    </Text>

                                                                </Stack>

                                                            </Card>

                                                        </SimpleGrid>

                                                        <Group justify="flex-end" mt="lg">

                                                            <Button
                                                                radius="xl"
                                                                leftSection={<EditNoteIcon />}
                                                                onClick={() => OpenEditmodal(item._id)}
                                                            >
                                                                Edit Alert
                                                            </Button>

                                                            <Popconfirm
                                                                title="Delete this alert?"
                                                                description="This action cannot be undone."
                                                                onConfirm={() => confirm(item._id)}
                                                                okText="Yes"
                                                                cancelText="No"
                                                            >
                                                                <Button
                                                                    color="red"
                                                                    radius="xl"
                                                                    leftSection={<DeleteOutlineIcon />}
                                                                    loading={loading.delloading}
                                                                >
                                                                    Delete
                                                                </Button>
                                                            </Popconfirm>

                                                        </Group>

                                                    </Accordion.Panel>

                                                </Accordion.Item>
                                            )

                                        })}

                                    </Accordion>
                                )
                            }

                        </Card>

                    </Container>
                </Box>
            </Box>
        </>
    )
}

export default AlertHistory;